<template>
  <div class="accounts">
    <pc-block>
      <div class="pc-block__title">
        {{ $t('pc.accounts.title') }}
        <v-tooltip
          theme="pc-tooltip"
        >
          <icu-icon class="pc-question dark" />
          <template #popper>
            <div class="popper-content">
              <div class="popper-content__text">
                {{ $t('pc.accounts.accounts-tooltip-text') }}
                <br />
                <br />
                <pc-contacts email-to="support"></pc-contacts>
              </div>
            </div>
          </template>
        </v-tooltip>
      </div>
      <template v-if="!payout.length">
        <p class="accounts__description">
          {{ $t('pc.accounts.fx-accounts-text') }}
        </p>
        <div class="pc-cards">
          <pc-payout-account type="loading"></pc-payout-account>
        </div>
      </template>
      <template v-else>
        <div v-if="isDesktop" class="pc-cards__wrap desktop">
          <div class="pc-cards">
            <pc-payout-account
              v-for="(account, index) in payout"
              :key="index + ''+ account.id"
              :type="account.is_processing ? 'inactive': ''"
              :account-data="account"
            ></pc-payout-account>
          </div>
        </div>
        <template v-else>
          <div class="swiper payout-swiper">
            <div class="swiper-wrapper">
              <pc-payout-account
                v-for="(account,index) in payout"
                :key="index + '' + account.id"
                :type="account.is_processing ? 'inactive': ''"
                :account-data="account"
                class="swiper-slide"
              ></pc-payout-account>
            </div>
          </div>
        </template>
      </template>
    </pc-block>
    <pc-block>
      <div class="pc-block__title">
        {{ $t('pc.accounts.bank-cards') }}  <v-tooltip

          theme="pc-tooltip"
        >
          <icu-icon class="pc-question dark" />
          <template #popper>
            <div class="popper-content">
              <div class="popper-content__text">
                {{ $t('pc.accounts.cards-tooltip-text') }}
                <br />
                <br />
                <pc-contacts email-to="support"></pc-contacts>
              </div>
            </div>
          </template>
        </v-tooltip>
      </div>
      <template v-if="isReady">
        <div v-if="isDesktop" class="pc-cards">

          <pc-verified-account
            v-for="(account, index) in verified"
            :key="index + ''+ account.id"
            :account-data="account"
            :type="account.is_processing ? 'inactive': 'active'"
            :currencies-for-payout-set="getCurrenciesForPayout(account)"
            @delete-card="deleteAccount(account)"
            @add-account="addCard(account)"
            @manage-cards="manageCards"
            @set-payment="checkPayment"
          ></pc-verified-account>
          <pc-verified-account type="blank" @click.native="addAccount()"></pc-verified-account>
        </div>
        <template v-else>
          <div :key="verified.length + $i18n.locale" class="swiper verified-swiper">
            <div class="swiper-wrapper">
              <pc-verified-account
                v-for="(account, index) in verified"
                :key="index + ''+ account.id"
                :account-data="account"
                :type="account.is_processing ? 'inactive': 'active'"
                :currencies-for-payout-set="getCurrenciesForPayout(account)"
                class="swiper-slide"
                @delete-card="deleteAccount(account)"
                @manage-cards="manageCards"
                @add-account="addCard(account)"
                @set-payment="checkPayment"
              ></pc-verified-account>
              <pc-verified-account class="swiper-slide" type="blank" @click.native="addAccount()"></pc-verified-account>
            </div>
          </div>
        </template>
      </template>
    </pc-block>

    <pc-modal-wrapper v-if="showCardManage">
      <pc-modal-container class="pc-cards-modal" @close="closeManageCards">
        <div class="pc-modal__content pc-modal__content-cards">
          <div class="pc-cards-modal__title">
            {{ cardsManageAccount.iban }}: {{ $t('pc.accounts.verified-cards') }}
          </div>
          <div v-if="isDesktop" class="pc-cards">

            <pc-bank-card
              v-for="(card, index) in cardsManageAccount.cards"
              :key="index + ''+ card.uuid"
              :account-data="cardsManageAccount"
              :card-data="card"
              :type="card.is_processing ? 'inactive': 'active'"
              @delete-card="deleteCard(card)"
            ></pc-bank-card>
            <pc-bank-card v-if="cardsManageAccount.cards.length < settings.MAX_IBAN_CARDS_COUNT" type="blank" @click.native="addCard(cardsManageAccount)"></pc-bank-card>
          </div>
          <div v-else class="tablet cards-swiper swiper">
            <div class="swiper-wrapper">
              <pc-bank-card
                v-for="(card, index) in cardsManageAccount.cards"
                :key="index + ''+ card.uuid"
                :account-data="cardsManageAccount"
                :card-data="card"
                :type="card.is_processing ? 'inactive': 'active'"
                class="swiper-slide"
                @delete-card="deleteCard(card)"
              ></pc-bank-card>
              <pc-bank-card
                v-if="cardsManageAccount.cards.length < settings.MAX_IBAN_CARDS_COUNT"
                class="swiper-slide"
                type="blank"
                @click.native="addCard(cardsManageAccount)"
              ></pc-bank-card>
            </div>
          </div>

        </div>
      </pc-modal-container>
    </pc-modal-wrapper>

    <pc-modal-wrapper v-if="showDeleteCardModal">
      <pc-modal-container class="pc-delete-card" @close="showDeleteCardModal=false">
        <div class="pc-modal__content">
          <div class="pc-modal__text" v-html="$t('pc.accounts.account-delete-confirm') + (isCardDelete? $t('pc.accounts.current-card') : $t('pc.accounts.current-account')) + '?'">
          </div>
        </div>
        <div class="pc-modal__actions">
          <pc-button
            variant="dark"
            :disabled="false"
            @click.native="confirmDeleteCard"
          >
            <template v-if="showDeleteLoader">
              <icu-icon class="pc-big-loader"></icu-icon>
            </template>
            <template v-else>
              {{ $t('pc.accounts.account-delete') }}
            </template>
          </pc-button>
          <pc-button
            variant="void"
            :disabled="false"
            @click="showDeleteCardModal=false"
          >
            {{ $t('pc.accounts.account-delete-cancel') }}
          </pc-button>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>
    <pc-modal-wrapper v-if="showSetPaymentModal">
      <pc-modal-container class="pc-delete-card" @close="showSetPaymentModal=false">
        <div class="pc-modal__content">
          <div
            class="pc-modal__text"
            v-html="$t('pc.accounts.change-payout', {iban: accountForPayout.iban, currency: getCurrencies(replaceCurrencies), card_number: accountForPayout.cards.length? '' : '<br/>'+ $t('pc.accounts.account-has-no-card') }) + '?'"
          >

          </div>
        </div>
        <div class="pc-modal__actions">
          <pc-button
            variant="dark"
            :disabled="false"
            @click.native="setPayment"
          >
            <template v-if="showSetPaymentLoader">
              <icu-icon class="pc-big-loader"></icu-icon>
            </template>
            <template v-else>
              {{ $t('pc.accounts.confirm-replace') }}
            </template>
          </pc-button>
          <pc-button
            variant="void"
            :disabled="false"
            @click.native="showSetPaymentModal=false"
          >
            {{ $t('pc.accounts.cancel-replace') }}
          </pc-button>
        </div>
      </pc-modal-container>
    </pc-modal-wrapper>

    <pc-modal-wrapper v-if="showAddAccountModal">
      <pc-modal-container class="pc-edit-account" @close="showAddAccountModal=false">
        <edit-account
          :account="accountToEdit"
          :is-card-edit="isCardEdit"
          :backend-errors="backendErrors"
          @update-field="updateField"
          @add-file="addFile"
          @delete-file="deleteFile"
          @add-card="addCardToAccount"
          @delete-card="deleteCardFromAccount"
          @send-form="sendForm"
          @close="showAddAccountModal = false"
        ></edit-account>
      </pc-modal-container>
    </pc-modal-wrapper>
  </div>
</template>

<script>
import PcBlock from '@/components/views/PrivateCabinet/PcBlock'
import PcVerifiedAccount from '@/components/views/PrivateCabinet/PcVerifiedAccount.vue'
import PcPayoutAccount from '@/components/views/PrivateCabinet/PcPayoutAccount.vue'
import IcuIcon from '@/components/common/IcuIcon'
import {api} from '@/api/api'
import PcModalWrapper from '@/components/modals/PcModalWrapper'
import PcModalContainer from '@/components/modals/PcModalContainer'
import FourthStep from '@/components/views/RegisterPage/steps/FourthStep'
import EditAccount from '@/components/views/PrivateCabinet/EditAccount'
import PcButton from '@/components/common/PcButton'
import {makePreviewFromImage} from '@/utils'
import {cloneDeep, get, setWith} from 'lodash'
import {v4 as uuidv4} from 'uuid'
import {mapGetters} from 'vuex'
import PcBankCard from '@/components/views/PrivateCabinet/PcBankCard.vue'
import {getBackendErrorMessage} from '@/errorHandler'
import Swiper from 'swiper'
import 'swiper/swiper.scss'
import PcContacts from '@/components/common/PcContacts.vue'


export default {
  name: 'PcAccounts',
  components: {
    PcContacts,
    PcBankCard,
    PcButton,
    EditAccount,
    FourthStep,
    PcModalContainer,
    PcModalWrapper,
    IcuIcon,
    PcVerifiedAccount,
    PcPayoutAccount,
    PcBlock
  },

  uuidv4,
  cardTemplate: {
    card_number: '',
    card_expire: '',
    doc: []
  },
  accountTemplate: {
    currency:[],
    iban:'',
    swift:'',
    additional_information:'',
    bank:'',
    cards:[],
    doc:[]
  },
  currencies: {
    1: '₴',
    2: '$',
    3: '€'
  },
  sliderParams: {
    allowTouchMove: true,
    slidesPerView: 'auto'
  },
  data(){
    return {
      showDeleteLoader: false,
      isCardDelete: false,
      showCardManage: false,
      isDesktop: false,
      payout: [],
      verified: [],
      cardToDelete: null,
      accountToEdit: cloneDeep(this.$options.accountTemplate),
      cardsManageAccount: null,
      showDeleteCardModal: false,
      showAddAccountModal: false,
      showSetPaymentModal: false,
      isCardEdit: false,
      accountForPayout: null,
      verifyId: null,
      updateTime: new Date().toString(),
      backendErrors:[],
      replaceCurrencies: [],
      showSetPaymentLoader: false,
      isReady: false,
      swiper: null,
      cardSlider: null,

    }
  },
  computed: {
    ...mapGetters(['otpConfirmed', 'userInfo', 'settings', 'haveAccountsUpdate'])
  },
  watch:{
    async otpConfirmed(newVal){
      if(newVal === this.verifyId) {
        await this.getAccounts()
        const index = this.verified.findIndex(el => el.id === this.cardsManageAccount?.id)
        this.cardsManageAccount = this.verified[index]

      }
    },
    'payout'() {
      this.initSliders()
    },
    'verified'() {
      this.initSliders()
    },
    '$i18n.locale'() {
      this.initSliders()
    },
    isDesktop() {
        this.initSliders()
    },

    showCardManage(newVal) {
      if(newVal) {
        this.$nextTick(() => {
         const cardsSwiper = document.querySelector('.cards-swiper')
          new Swiper(cardsSwiper, {
            allowTouchMove: true,
            slidesPerView: 'auto',
          })
        })
      }
    },

    haveAccountsUpdate(newVal){
      if(newVal){
        this.getAccounts()
        this.$store.dispatch('setHaveAccountsUpdate', false)
      }
    }
  },
  async mounted(){
    this.checkDesktop()
    window.addEventListener('resize', this.checkDesktop)
    await this.$store.dispatch('setHaveAccountsUpdate', false)
    await this.getAccounts()
    this.isReady = true
    this.initSliders()
  },
  destroyed() {
    window.removeEventListener('resize', this.checkDesktop)
  },
  methods:{
    initSliders() {
      this.$nextTick(() => {
        if (!this.isDesktop) {
          this.swiper = new Swiper('.swiper', {
                allowTouchMove: true,
                slidesPerView: 'auto',
              }
          )
        }
      })
    },
    getCurrenciesForPayout(account) {
      let currencies = [2,3]
      this.payout.forEach(el => {
        if(el.iban === account.iban) {
          account.currency.forEach(currency => {
            if (el.currency.includes(currency) || currency === 1) {
              currencies = currencies.filter(item => item !== currency)
            }
          })
        }
      })
      return currencies.filter(el=> account.currency.includes(el))

    },
    manageCards(account) {
      this.showCardManage = true
      const index = this.verified.findIndex(el => el.id === account.id)
      this.cardsManageAccount = this.verified[index]
    },
    closeManageCards() {
      this.showCardManage = false
      this.accountToEdit = cloneDeep(this.$options.accountTemplate)
    },

    async getAccounts() {
      try {
        const {data} = await api.cabinet.getAccounts()
        this.payout = data.payout
        this.verified = data.verified
        this.payout.forEach(account => {
          const index = this.verified.findIndex(el => account.iban === el.iban)
          this.verified[index].currency_in_use = account.currency
        })
        this.updateTime = new Date().toString()
      }catch(err) {
        console.log(err)
      }
    },

    checkDesktop() {
      this.isDesktop = window.innerWidth > 1200
    },

    deleteAccount(account) {
      this.isCardDelete = false
      this.showDeleteCardModal = true
      this.cardToDelete = account
    },
    deleteCard(card){
      this.isCardDelete = true
      this.showDeleteCardModal = true
      this.cardToDelete = card
    },

    async confirmDeleteCard(){
      this.showDeleteLoader = true
      try {
        if (this.isCardDelete) {
          await api.cabinet.deleteCard({id:this.cardsManageAccount.id, card_number: this.cardToDelete.card_number})
        } else {
          this.sendOtp(this.cardToDelete.id)
        }


        setTimeout(async() => {
          if(this.isCardDelete) {
            await this.getAccounts()
          }
          const index = this.verified.findIndex(el => el.id === this.cardsManageAccount.id)
          this.cardsManageAccount = this.verified[index]
        },0)

      } catch(err) {
        console.log(err)
        this.$toast.error(this.$i18n.t(getBackendErrorMessage(err)))
      }
      this.showDeleteLoader = false
      this.showDeleteCardModal = false
    },
    addAccount() {
      this.backendErrors = {}
      this.isCardEdit = false
      this.accountToEdit = cloneDeep(this.$options.accountTemplate)
      //this.accountToEdit.cards.push(cloneDeep(this.$options.cardTemplate))
      this.showAddAccountModal = true
    },
    addCardToAccount(){
      this.accountToEdit.cards.push(cloneDeep(this.$options.cardTemplate))
    },

    addCard(account){
      this.backendErrors = {}
      this.accountToEdit = cloneDeep(this.$options.accountTemplate)
      this.accountToEdit.cards.push(cloneDeep(this.$options.cardTemplate))
      this.isCardEdit = true
      for (const key in account) {
        if(key !== 'cards') {
          this.accountToEdit[key] = account[key]
        }
      }
      this.showAddAccountModal = true
    },
    deleteCardFromAccount(cardIndex){
      this.accountToEdit.cards.splice(cardIndex, 1)
    },

    checkPayment({account, currency}) {
      const replaceCurrencies = []
      this.accountForPayout = cloneDeep(account)
      const currentPayoutCurrencies = []
      this.payout.forEach(account => {
        currentPayoutCurrencies.push(...account.currency)
      })

      currentPayoutCurrencies.forEach(item => {
        if(currency.includes(item)){
          replaceCurrencies.push(item)
        }
      })

      this.replaceCurrencies = Array.from(new Set(replaceCurrencies))
      this.accountForPayout.currency = currency
      if(this.replaceCurrencies.length) {
        this.showSetPaymentModal = true
      } else {
        this.setPayment()
      }

    },

    async setPayment() {
      const accountIndex = this.verified.findIndex( el => el.id ===this.accountForPayout.id)
      this.$set(this.verified[accountIndex], 'is_loading', true)
      try {
        this.showSetPaymentLoader = true
        await this.sendOtp(this.accountForPayout.id, 'account_payout')

        this.showSetPaymentModal = false
        //await this.getAccounts()
      }catch(err){
        this.$toast.error(this.$t('notifications.something-went-wrong'))
        console.log(err)
      }
      this.showSetPaymentLoader = false
      setTimeout(() => {this.verified[accountIndex].is_loading = false},500)

    },

    getCurrencies(currencies) {
      let str = ''
        currencies.forEach((el, index) => {
          if(index) {
            str += ', '
          }
          str += this.$options.currencies[el]
        })
      return str
    },

    updateField({formKey, value}) {
      setWith(this.accountToEdit, formKey, value, (nsValue, key, nsObject) => {
        return this.$set(nsObject, key, nsValue)
      })
    },

    async addFile({formKey, file}) {
      let fileData = {
        _id: this.$options.uuidv4(),
        name: file.name,
        newAdded: true,
        isUploading: false,
        hasError: false,
        uploadPercent: 0,
        file
      }
      if (file.type.includes('image')) {
        fileData.src = await makePreviewFromImage(file)
      }

      let newFileArray = []

        newFileArray = [
          ...get(this.accountToEdit, formKey),
          fileData
        ]
      this.updateField({formKey, value: newFileArray})

      if (file.type.includes('image')) {
        fileData.src = await makePreviewFromImage(file)
      }
    },

    deleteFile(fileData) {
      const formKey = fileData.formKey
      const data =  this.accountToEdit
      const newFileArray = get(data, formKey).filter(file => file._id !== fileData.file._id)
      this.updateField({formKey, value:newFileArray})
    },

    async sendForm() {
        if(this.isCardEdit){
          const id = this.accountToEdit.id
          await this.uploadFile(this.accountToEdit.cards[0].doc[0])

         const formData = {
            card_number: this.accountToEdit.cards[0].card_number,
            card_expire: this.accountToEdit.cards[0].card_expire,
            doc: []
         }
         formData.doc[0] = this.accountToEdit.cards[0].doc[0].id

         try {
          const {data} = await api.cabinet.createCard(id, formData)
           this.showAddAccountModal = false
           await this.getAccounts()
           const index = this.verified.findIndex(el => el.id === this.cardsManageAccount?.id)
           this.cardsManageAccount = this.verified[index]
         }catch(err){
            this.$set(this.backendErrors, 'cards', [err.response.data])
         }
        } else {
          const formData = cloneDeep(this.accountToEdit)

          const cards = formData.cards.filter(el => el.card_number )
          formData.cards = cards.length ? cards : null

          await Promise.all(this.accountToEdit.doc.map(async (file) => {
            await this.uploadFile(file)

          }))
          this.accountToEdit.cards = await Promise.all (
              this.accountToEdit.cards.map(async card => {
                await this.uploadFile(card.doc[0])
                card.doc[0] = card.doc[0].id
                return card
              })
          )
          formData.cards = this.accountToEdit.cards
          this.accountToEdit.doc.forEach((doc, index) => {
            formData.doc[index] = doc.id
          })
          formData.additional_information = this.accountToEdit.additional_information
          try {
            const {data} = await api.cabinet.createAccount(formData)
            this.showAddAccountModal = false
            await this.getAccounts()
          } catch(err) {
            this.backendErrors = err.response.data
            console.log(err)
          }

        }
    },

    async sendOtp(id, action = 'account_delete') {
      this.verifyId = id
      const getCodeApi = action === 'account_payout' ? api.cabinet.setPayout : api.cabinet.deleteAccount
      const getCodeApiData =  action === 'account_payout'
          ? {id: this.accountForPayout.id, currency:this.accountForPayout.currency, action}
          : {id, action}
      const otpData = {
        id,
        getCodeApi,
        getCodeApiData,
        confirmCodeApi: api.cabinet.confirmAccountActionOtp,
        confirmCodeApiData: getCodeApiData,
        hideCountdown: false
      }

      await this.$store.dispatch('showOtp', otpData)
    },

    async uploadFile(fileData){
      fileData.isUploading = true

      const formData = new FormData()
      formData.append('doc', fileData.file)

      const onUploadProgressCallback = ev => {
        fileData.uploadPercent = Math.round(ev.loaded * 100 / ev.total)
      }

      try {
        const { data } = await api.profile.uploadFile(formData, onUploadProgressCallback)
        Object.assign(fileData, data)

      } catch (e) {
        fileData.error = e.response.data.doc
        fileData.hasError = true
      } finally {
        fileData.isUploading = false
        fileData.newAdded = fileData.hasError
      }

    },
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/scss/theme.scss";
.pc-cards {
  margin: 0 -24px 0 -24px;
  display: flex;
  flex-wrap: wrap;
}
.swiper {
  margin:  0 -52px 0 -52px;
  padding: 0 40px;
}

.accounts {
  max-width:1346px;

  &__description {
    color: $passive-text;
  }
}
.popper-content__text {
  max-width: 329px;
}

.pc-edit-account {
  max-width: 892px;
  width: 892px;
}
.pc-modal__actions {
  & > * {
    width: 260px;
    flex-grow: 0 !important;
  }
}
.pc-delete-card {
  width: 600px;
}

.pc-cards-modal {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  max-width: 892px;
  width: 892px;
  overflow-x: hidden;

  .pc-modal__content {
    justify-content: space-between;
    overflow: hidden;

  }
  .pc-cards {
    overflow-x: hidden;
    overflow-y: scroll;
  }

  &__title {
    font-weight: 500;
    margin-bottom: 30px;
    margin-top: 15px;
  }
}
.pc-cards {
  display: flex;
  flex-wrap: wrap;
}

.pc-modal__content-cards {
  .tablet {
    flex-grow: 1;
  }
}

@media (max-width: 500px) {
  .pc-cards-modal .pc-modal__content {
    overflow: visible;
  }
}


</style>
